import _ from 'lodash';
import { ONLYWTBCOUNTRIES } from '../constants';

export function isOnlyWTBcountry(isoCode: string) {
    return _.includes(ONLYWTBCOUNTRIES, isoCode);
}
